"use client";

import { usePathname } from "next/navigation";
import Navbar from "@/components/navbar";
import SmoothScroll from "@/components/SmoothScroll";
import ScrollToTop from "@/components/ScrollToTop";
import WhatsAppButton from "@/components/WhatsAppButton";
import type { Review } from "@/components/reviews/ReviewsSection";
import { ReviewsProvider } from "@/components/reviews/ReviewsContext";
import { COMPANY } from "@/lib/company";

interface AppShellProps {
  children: React.ReactNode;
  /**
   * The footer, rendered by the server layout. Passing it as a prop keeps it a
   * Server Component (plain HTML, no hydration) even though AppShell is a
   * client component; its links stay in the initial HTML for crawlers.
   */
  footer: React.ReactNode;
  footerSettings: any;
  reviews: Review[];
}

export default function AppShell({
  children,
  footer,
  footerSettings,
  reviews,
}: AppShellProps) {
  const pathname = usePathname();
  const systemRoutes = ['/admin', '/portal', '/developer', '/developer-login', '/client', '/client-login','/tester','/tester-login'];
  const isSystemRoute = systemRoutes.some(route => pathname.startsWith(route));
  // Reviews are homepage-only social proof: the homepage places
  // ReviewsSection itself (components/home/v7/HomeReviews.tsx, lazy-loaded
  // there), reading the layout-fetched reviews from this provider.

  if (isSystemRoute) {
    return <>{children}</>;
  }

  return (
    <SmoothScroll>
      <ScrollToTop />
      <Navbar
        socials={{
          linkedinUrl: footerSettings?.linkedinUrl,
          facebookUrl: footerSettings?.facebookUrl,
          xUrl: footerSettings?.twitterUrl,
        }}
      />
      <ReviewsProvider reviews={reviews}>{children}</ReviewsProvider>
      {footer}
      <WhatsAppButton phoneNumber={footerSettings?.contactPhone || COMPANY.phone} />
    </SmoothScroll>
  );
}
